var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPin = function SvgPin(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 21.3836L12.1303 20.8571C17.4308 16.43 20.125 12.5645 20.125 9.16663C20.125 4.35473 16.1987 0.916626 11.5 0.916626C6.80134 0.916626 2.875 4.35473 2.875 9.16663C2.875 12.5645 5.56917 16.43 10.8697 20.8571L11.5 21.3836ZM11.5 18.9414C7.00217 15.064 4.79166 11.7784 4.79166 9.16663C4.79166 5.40518 7.82394 2.74996 11.5 2.74996C15.1761 2.74996 18.2083 5.40518 18.2083 9.16663C18.2083 11.7784 15.9978 15.064 11.5 18.9414ZM11.5 4.58329C14.1464 4.58329 16.2917 6.63532 16.2917 9.16663C16.2917 11.6979 14.1464 13.75 11.5 13.75C8.85364 13.75 6.70833 11.6979 6.70833 9.16663C6.70833 6.63532 8.85364 4.58329 11.5 4.58329ZM8.625 9.16663C8.625 7.64784 9.91218 6.41663 11.5 6.41663C13.0878 6.41663 14.375 7.64784 14.375 9.16663C14.375 10.6854 13.0878 11.9166 11.5 11.9166C9.91218 11.9166 8.625 10.6854 8.625 9.16663Z",
    fill: "#00B8F8"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pin.1c9f55a9.svg";
export { ForwardRef as ReactComponent };